import { requestFactory } from './index';
const request = requestFactory('/api/usercenter');
export function verify(data) {
    return request({
        method: 'put',
        url: '/user/second/auth',
        data,
    });
}
